export default {
  registerForm: {
    title: 'サインアップ',
    registerSuccess: 'サインアップ完了',
    verification: {
      title:
        '{email} に送信された確認コードを入力し、検証後に登録を完了してください。',
      send: '確認コードが送信されました',
      noReceived: '確認コードが届きませんか?',
      resend: '再送信',
    },
    existAccount: 'すでにアカウントをお持ちですか？',
    backLogin: 'ログインに戻る',
    previousStep: '前のステップ',
    validatePassword: 'パスワードが一致しません',
    email: {
      placeholder: 'メールアドレスを入力してください',
      registered:
        'このメールアドレスは既に登録されています。ログインしてください',
    },
    is_agree: {
      legal_agreement: '利用規約',
      privacyPolicy: 'プライバシーポリシー',
      connectText: 'および',
      checkPrompt: 'プライバシーポリシーに同意してください',
    },
    contact: {
      name: '連絡先名',
      pleaseInput: '連絡先を入力してください',
      cell: '連絡先電話',
    },
    country: {
      placeholder: '国または地域',
    },
    organization: {
      placeholder: '会社',
    },
    representative: {
      placeholder: '推薦者名',
    },
    username: {
      placeholder: 'アカウント名',
      pleaseInput: 'ユーザー名を入力してください',
      complianceCheck:
        '英字で始まり、数字、英字、アンダースコアのみが使用可能で、長さは3～32文字以内である必要があります。',
      alreadyExist: 'ユーザー名は既に存在します',
    },
    password: {
      placeholder: 'パスワード',
      pleaseInput: 'パスワードを入力してください',
      specialCharacterCheck: 'パスワードに特殊文字を含めることはできません',
      characterCheck:
        'パスワードは8～20文字で、数字と大文字小文字の英字を組み合わせてください',
    },
    repassword: {
      placeholder: '確認用パスワード',
      pleaseInput: '確認用パスワードを入力してください',
    },
    submitBtn: {
      register: '登録({currentForm}/4)',
      nextStep: '次のステップ({currentForm}/4)',
    },
  },
  registerSuccessRouteToPc:
    'より良い製品体験のために、下記のリンクにPCでアクセスしてログインしてください。',
}
